import { render, staticRenderFns } from "./detail-download.vue?vue&type=template&id=1ab24904&scoped=true"
import script from "./detail-download.vue?vue&type=script&lang=js"
export * from "./detail-download.vue?vue&type=script&lang=js"
import style0 from "./detail-download.vue?vue&type=style&index=0&id=1ab24904&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ab24904",
  null
  
)

export default component.exports